AccountNotificationsController.$inject = ['API', 'Club', '_', 'alerts'];

/* @ngInject */
function AccountNotificationsController(API, Club, _, alerts) {
    var vm = this;
    var account = API.one('account').one('notifications', Club.id);
    vm.title = 'AccountNotificationsController';

    vm.loading = false;

    vm.configurations = [{
        id: 'new_online_booking',
        name: 'Enviarme un mail cada vez que se realiza una reserva online',
        checked: true
    }, {
        id: 'online_cancellation',
        name: 'Enviarme un mail cada vez que se edite/cancele un turno online',
        checked: true
    },
        /*{
                   id: '',
                   name: 'Enviarme un mail cada vez que se cambie la configuración del complejo',
                   checked: false
               }, */
    ];

    vm.save_notifications = function () {
        alerts.code().then(save_notifications)
    };

    activate();

    ////////////////

    function activate() {
        vm.loading = true;
        account.get()
            .then(function (notifications) {
                if (!notifications || !notifications.length) {
                    return;
                }

                _.each(vm.configurations, function (cfg) {
                    if (_.includes(notifications, cfg.id)) {
                        cfg.checked = false;
                    } else {
                        cfg.checked = true;
                    }
                });

            }).catch(alerts.errorHandler).finally(function () {
            vm.loading = false;
        });
    }

    function save_notifications(code) {
        vm.loading = true;
        var data = notifications_formatData(code);
        account.customPUT(data).then()
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

    function notifications_formatData(code) {
        return {
            code: code,
            notifications: _(vm.configurations).filter(['checked', false]).map('id').value()
        };
    }
}


export default AccountNotificationsController;